const Width = 1032;
const Gutter = 24;

export default {
    Width: `${Width}px`,
    Gutter: `${Gutter}px`,
};
